import { api } from './index'

type CheckoutSettings = {
  checkout_message: string | null
}

type OrderingConfigResponse = {
  ordering_config: CheckoutSettings
}

export const checkoutSettingsApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: build => ({
    getCheckoutSettings: build.query<OrderingConfigResponse, void>({
      query: () => 'ordering_config',
      providesTags: ['CheckoutSettings'],
    }),
    updateCheckoutSettings: build.mutation<
      OrderingConfigResponse,
      Partial<CheckoutSettings>
    >({
      query: settings => ({
        url: 'ordering_config',
        method: 'PATCH',
        body: { ordering_config: settings },
      }),
      invalidatesTags: ['CheckoutSettings'],
    }),
  }),
})

export const {
  useGetCheckoutSettingsQuery,
  useUpdateCheckoutSettingsMutation,
} = checkoutSettingsApi
